"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _isEmptyString = _interopRequireDefault(require("../utils/object/isEmptyString"));

var Color = /*#__PURE__*/function () {
  function Color(r, g, b) {
    var alpha = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    (0, _classCallCheck2["default"])(this, Color);
    (0, _defineProperty2["default"])(this, "_alpha", void 0);
    (0, _defineProperty2["default"])(this, "_blue", void 0);
    (0, _defineProperty2["default"])(this, "_green", void 0);
    (0, _defineProperty2["default"])(this, "_red", void 0);
    this._red = r;
    this._green = g;
    this._blue = b;
    this._alpha = alpha;
  }

  (0, _createClass2["default"])(Color, [{
    key: "toString",
    value: function toString() {
      return "rgba(".concat(this.red, ", ").concat(this.green, ", ").concat(this.blue, ", ").concat(this.alpha, ")");
    }
  }, {
    key: "alpha",
    get: function get() {
      return this._alpha;
    }
  }, {
    key: "blue",
    get: function get() {
      return this._blue;
    }
  }, {
    key: "green",
    get: function get() {
      return this._green;
    }
  }, {
    key: "red",
    get: function get() {
      return this._red;
    }
  }], [{
    key: "getColorFromHexColor",
    value: function getColorFromHexColor(hex) {
      var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      if ((0, _isEmptyString["default"])(hex) || hex[0] !== '#') {
        throw new Error("Invalid hex color string: ".concat(hex));
      } // Extract RGB components from the hex color string


      var hexNumeralString = hex.substring(1);
      var redString;
      var greenString;
      var blueString;

      switch (hexNumeralString.length) {
        case 3:
          redString = hexNumeralString[0] + hexNumeralString[0];
          greenString = hexNumeralString[1] + hexNumeralString[1];
          blueString = hexNumeralString[2] + hexNumeralString[2];
          break;

        case 6:
        case 8:
          redString = hexNumeralString.substr(0, 2);
          greenString = hexNumeralString.substr(2, 2);
          blueString = hexNumeralString.substr(4, 2);
          break;

        default:
          throw new Error("Invalid hex color string: ".concat(hex));
      } // Parse the RGB components into numbers


      var red = parseInt(redString, 16);
      var green = parseInt(greenString, 16);
      var blue = parseInt(blueString, 16);
      return new Color(red, green, blue, alpha);
    }
  }, {
    key: "isColor",
    value: function isColor(inputObject) {
      return inputObject instanceof Color;
    }
  }]);
  return Color;
}();

exports["default"] = Color;